import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {Field} from "react-final-form";
import {
    composeValidators,
    regRequiredValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {UserCity, IdLabelInterface} from "../../../../containers/RegistrationLoginPage/types";

import SelectV2 from "../../../HTMLEntities/SelectV2";
import {SINGLE_SELECT} from "../../../HTMLEntities/SelectV2/utils";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";
import {ChangeLocationIcon, ChangeLocationWrapper} from "../Styled";

interface UserCityFieldInterface {
    configuration: UserCity;
}
const UserCityField: React.FC<UserCityFieldInterface> = ({
    configuration,
}: UserCityFieldInterface) => {
    const {fieldName, editable, values: dropDownValues, selectedValue} = configuration;

    const [showLocationAsLabel, setShowLocationAsLabel] = useState<boolean>(
        selectedValue ? true : false,
    );
    const [labelCityObj, setLabelCityObj] = useState<IdLabelInterface | null>(selectedValue);
    const getItemsList = useCallback(() => {
        const itemsList: IdLabelInterface[] = [];
        dropDownValues &&
            dropDownValues.map((section) => {
                const {groupOptions} = section;
                groupOptions.map((mainOption: IdLabelInterface) => {
                    itemsList.push(mainOption);
                });
            });
        return itemsList;
    }, [dropDownValues]);

    const [flatItems, setFlatItems] = useState<IdLabelInterface[]>(() => {
        return getItemsList();
    });
    const isMounted = useRef(false);
    useEffect(() => {
        if (isMounted.current) {
            const itemsList: IdLabelInterface[] = getItemsList();
            setFlatItems(itemsList);
        } else {
            isMounted.current = true;
        }
    }, [getItemsList]);

    return useMemo(() => {
        return (
            <>
                {flatItems ? (
                    <Field
                        name={fieldName}
                        validate={composeValidators(
                            regRequiredValidate("Current city is mandatory"),
                        )}
                        {...(labelCityObj ? {initialValue: labelCityObj} : {})}
                    >
                        {(props) => {
                            return showLocationAsLabel ? (
                                <ChangeLocationWrapper>
                                    <ChangeLocationIcon />
                                    <strong>{labelCityObj?.label}</strong> is your current location.{" "}
                                    <span
                                        onClick={() => {
                                            setShowLocationAsLabel(false);
                                        }}
                                    >
                                        Change
                                    </span>
                                </ChangeLocationWrapper>
                            ) : (
                                <SelectV2
                                    placeholder="Current City"
                                    type={SINGLE_SELECT}
                                    items={flatItems}
                                    optGroupItem={dropDownValues ?? []}
                                    inputRFF={props.input}
                                    withSearch={true}
                                    isFocused={props?.meta?.active ?? false}
                                    isTouched={props?.meta?.touched}
                                    error={errorHandler(props?.meta)}
                                    selectedOption={labelCityObj ? [labelCityObj] : undefined}
                                    withOptGroup={true}
                                    isFilled={typeof props.input.value === "object"}
                                    isDisabled={!editable}
                                    onSelectedItemChange={(obj) => {
                                        const {selectedItem} = obj;
                                        setLabelCityObj(selectedItem ?? null);
                                        setShowLocationAsLabel(true);
                                    }}
                                />
                            );
                        }}
                    </Field>
                ) : (
                    ""
                )}
            </>
        );
    }, [flatItems, dropDownValues, editable, fieldName, showLocationAsLabel, labelCityObj]);
};
export default UserCityField;
